import React, { useEffect, useState } from 'react';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import CategoryService from '../../services/category.service';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
import styles from '../Home/ServiceSection.module.css';
import { getLocaleContent } from '@helper/locale-content.js';
import { useRouter } from 'next/router';
import { useBooking } from '@contexts/BookingContext';
import Link from 'next/link';
import {safeHtml} from '@helper/sanitize-html';

/**
 * Component hiển thị danh sách dịch vụ y tế
 * Cho phép user click "Đặt lịch khám" để tự động fill form
 */
export default function MedicalFacilityServiceSection({ medicalFacility }) {
    const { locale } = useRouter();
    const [productCategories, setProductCategories] = useState([]);
    const { setBookingInfo } = useBooking();

    useEffect(() => {
        const businessId = medicalFacility?.business_id;
        if (!businessId) return;

        const categoryService = new CategoryService();
        categoryService
            .getProductCategoryForWeb({
                locale,
                business_id: businessId,
                limit: 10,
            })
            .then(response => {
                setProductCategories(response);
            })
            .catch(error => {
                console.error('Lỗi khi lấy danh sách dịch vụ:', error);
            });
    }, [locale, medicalFacility?.business_id]);
    const swiperConfig = {
        spaceBetween: 40,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 4.5,
                spaceBetween: 20,
            },
        },
        pagination: {
            type: 'progressbar',
        },
    };

    // Không hiển thị component nếu không có data
    if (!productCategories || productCategories.length === 0) {
        return null;
    }

    return (
        <>
            <section className="svc container" aria-labelledby="svc-title">
                <header className="svc__head">
                    <div className="svc__left">
                        <h2 id="svc-title" className="svc__title">
                            {getLocaleContent(locale, 'page.service.title')}{' '}
                            <span>{getLocaleContent(locale, 'page.service.sub-title')}</span>
                        </h2>
                        <p className="svc__lead">{getLocaleContent(locale, 'page.service.lead')}</p>
                    </div>
                    <Link href="/san-pham-dich-vu">
                        <a className="svc__all">
                            {getLocaleContent(locale, 'common.see-all')}{' '}
                            <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M8 5l8 7-8 7"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </a>
                    </Link>
                </header>

                <Swiper
                    {...swiperConfig}
                    className={`${styles['swiper-container']} ${styles['bleed-right']}`}
                    style={{
                        paddingBottom: '18px',
                        overflow: 'hidden',
                    }}>
                    {productCategories.map((productCategory, index) => (
                        <SwiperSlide key={index}>
                            <article className="svc-card">
                                <figure className="svc-card__media">
                                    <img
                                        src={productCategory.picture_url}
                                        alt={productCategory.category_name}
                                        onError={e => {
                                            e.target.src = '/bw_image/service-default.png';
                                        }}
                                    />
                                </figure>

                                <div className="svc-card__content">
                                    <h3 className="svc-card__title">{productCategory.category_name}</h3>

                                    <div className="svc-card__more">
                                        <div dangerouslySetInnerHTML={safeHtml(productCategory.description)}></div>
                                        <img src="/bw_image/chevron-right.svg" alt="" />
                                        <a
                                            className="cta"
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();

                                                // Set dữ liệu đặt lịch cho dịch vụ
                                                // Clear doctor và user_id khi click từ dịch vụ
                                                console.log('[MedicalFacilityServiceSection] Click đặt lịch từ dịch vụ:', {
                                                    business_id: medicalFacility?.business_id,
                                                    department_id: productCategory.department_id,
                                                    department_name: productCategory.department_name
                                                });
                                                setBookingInfo({
                                                    business_id: medicalFacility?.business_id || '',
                                                    department_id: productCategory.department_id || '',
                                                    department: productCategory.department_name || '',
                                                    doctor: '', // Clear doctor
                                                    user_id: '' // Clear user_id
                                                });

                                                // Scroll xuống form đặt lịch
                                                const formSection = document.querySelector('.register-section');
                                                if (formSection) {
                                                    const offset = 150; // Khoảng cách từ top
                                                    const elementPosition = formSection.offsetTop;
                                                    const offsetPosition = elementPosition - offset;

                                                    window.scrollTo({
                                                        top: offsetPosition,
                                                        behavior: 'instant',
                                                    });
                                                }
                                            }}>
                                            <img className="icon" src="/bw_image/ic_calendar.svg" alt="" />
                                            {getLocaleContent(locale, 'common.booking')}
                                        </a>
                                    </div>
                                </div>
                            </article>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
        </>
    );
}
